import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  partnerForEdit: {
    id: undefined,
    name: "",
    title: "",
    sellerFee: "",
    feature: "",
    description: "",
    price: "",
    iconUrl: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
  stateData: {},
  selectedTab: 0,
  partnerId: undefined,
  showpartnerPopover: false,
  showDeleteDialog: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const partnerSlice = createSlice({
  name: "partner",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // category loader
    partnerListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    partnerList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadpartnerForEdit: (state, action) => {
      const payload = action.payload;

      state.partnerForEdit.name = payload.name;
      state.partnerForEdit.id = payload.id;
      state.partnerForEdit.title = payload.title;
      state.partnerForEdit.sellerFee = payload.sellerFee;
      state.partnerForEdit.feature = payload.feature;
      state.partnerForEdit.description = payload.description;
      state.partnerForEdit.price = payload.price;
      state.partnerForEdit.iconUrl = payload.iconUrl;
    },
    loadPartnerMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
    loadState: (state, action) => {
      state.stateData = action.payload;
    },
    setTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    openPartnerApprove: (state, action) => {
      const { partnerId } = action.payload;

      state.partnerId = partnerId;
      state.showPartnerPopover = !state.showPartnerPopover;
    },
    setDeleteDialogData: (state, action) => {
      state.showDeleteDialog = !state.showDeleteDialog;
      state.partnerId = action.payload;
    },
  },
});
